import GraphTable from './GraphTable';

export default GraphTable;
